import cx from "classnames";
import type { ReactNode, ButtonHTMLAttributes } from "react";
import styles from "./Button.module.scss";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  variant?: "primary" | "ghost";
  className?: string;
};

export const Button = ({
  children,
  variant = "primary",
  className,
  ...props
}: ButtonProps) => (
  <button
    className={cx(styles.button, {
      [styles.primary]: variant === "primary",
      [styles.ghost]: variant === "ghost",
    }, className)}
    {...props}
  >
    {children}
  </button>
);
